import { commonjsGlobal as i, getDefaultExportFromCjs as n } from "../../../_virtual/_commonjsHelpers.js";
import { d as p } from "../../credit-card-type/dist/index.js";
import "./cardholder-name.js";
import "./card-number.js";
import "./expiration-date.js";
import "./expiration-month.js";
import "./expiration-year.js";
import "./cvv.js";
import "./postal-code.js";
import { __exports as _ } from "../../../_virtual/cardholder-name.js";
import { __exports as c } from "../../../_virtual/card-number.js";
import { __exports as d } from "../../../_virtual/expiration-date.js";
import { __exports as f } from "../../../_virtual/expiration-month.js";
import { __exports as u } from "../../../_virtual/expiration-year.js";
import { __exports as l } from "../../../_virtual/cvv.js";
import { __exports as s } from "../../../_virtual/postal-code.js";
var m = i && i.__createBinding || (Object.create ? function(r, e, t, a) {
  a === void 0 && (a = t);
  var o = Object.getOwnPropertyDescriptor(e, t);
  (!o || ("get" in o ? !e.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return e[t];
  } }), Object.defineProperty(r, a, o);
} : function(r, e, t, a) {
  a === void 0 && (a = t), r[a] = e[t];
}), v = i && i.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), x = i && i.__importStar || function(r) {
  if (r && r.__esModule) return r;
  var e = {};
  if (r != null) for (var t in r) t !== "default" && Object.prototype.hasOwnProperty.call(r, t) && m(e, r, t);
  return v(e, r), e;
}, b = x(p), h = _, j = c, y = d, O = f, g = u, C = l, D = s, M = {
  creditCardType: b,
  cardholderName: h.cardholderName,
  number: j.cardNumber,
  expirationDate: y.expirationDate,
  expirationMonth: O.expirationMonth,
  expirationYear: g.expirationYear,
  cvv: C.cvv,
  postalCode: D.postalCode
}, N = M;
const J = /* @__PURE__ */ n(N);
export {
  J as default
};
